import React from 'react'
import styled, { withTheme } from 'styled-components'

import { ColoredIcon } from '../../../../../src/ui/icons/Icon.jsx'
import { Input2 } from '../../../../../src/ui/inputs/Input2.jsx'
import { getThemeVal, getThemeColor } from '../../../../../src/utils/styled-component-tools.js'

import { FlightTypeToggle } from './FlightTypeToggle.jsx'

const WidgetWrapper = styled.div`
  width: 100%;
  padding: ${getThemeVal('header.paddingMobile', '12px 10px')};
`

const TopRow = styled.div`
  display: flex;
  margin-bottom: 10px;
  align-items: center;
`

const FlightTypeToggleStyled = styled(FlightTypeToggle)`
  margin-top: 10px;
`

const BackButton = styled.button`
  display: flex;
  flex: 0 1 auto;
  border: none;
  align-items: center;
  user-select: none;
  background-color: ${getThemeColor('widgetIconFill', '#333333')};
  background-color: ${getThemeColor('widgetBackground', '#f9f9f9')};
  ${({ theme }) => theme.fontSize('12px')};
  cursor: pointer;
  position: relative;
  padding: 0 16px 0 6px;
`

const InputWrapper = styled.div`
  background-color: ${getThemeColor('widgetText', '#333333', 0.1)};
  border-radius: 1px;
  display: flex;
  align-items: center;
  flex: 1 1 auto;

  button {
    width: 32px;
    outline: none;
    border: none;
    background: transparent;
    padding: 0;
    position: relative;
  }
`

const Input2Styled = styled(Input2)`
  input {
    ${({ theme }) => theme.fontSize('16px')};
  }
`

const HeaderViewMobile = ({
  placeholder,
  currentFlightType,
  searchTerm,
  onFlightTypeSwitched,
  onSearchTermChange,
  theme,
  onBackButtonClicked,
  T
}) => {
  return (
    <WidgetWrapper>
      <TopRow>
        <BackButton aria-label={T('ui:Navigate back')} data-cy='HeaderBackButton' onClick={() => onBackButtonClicked()}>
          <ColoredIcon
            className="icon"
            width={32}
            height={32}
            id="arrow-left"
            fillColor={theme.colors.widgetIconFill}
          />
        </BackButton>

        <InputWrapper>
          <Input2Styled
            color={theme.colors.widgetText}
            placeholder={placeholder}
            value={searchTerm}
            onChange={onSearchTermChange}
            title={placeholder}
            T={T}
          />
        </InputWrapper>
      </TopRow>

      <FlightTypeToggleStyled
        currentFlightType={currentFlightType}
        onFlightTypeClicked={onFlightTypeSwitched}
        T={T}
      />
    </WidgetWrapper>
  )
}

export default withTheme(HeaderViewMobile)
